import { toAbsoluteUrl } from './siteUrl';

type BreadcrumbTrailItem = {
  name: string;
  url?: string | null;
};

/**
 * Builds `BreadcrumbList` structured data mirroring what the breadcrumb components display.
 *
 * Both trails on the site (`components/BreadCrumb` and sailor-ui's `BlogBreadcrumb`) render a
 * leading "Home" link that is not part of the caller's array, so it is prepended here to keep the
 * markup and the visible trail in agreement.
 *
 * @param trail crumbs after Home, in display order
 */
export const buildBreadcrumbJsonLd = (trail: BreadcrumbTrailItem[]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [{ name: 'Home', url: '/' }, ...trail].map((crumb, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: crumb.name,
    // Google treats `item` as optional on the final crumb, which is the page being viewed. Crumbs
    // without a url are exactly those the components render as plain text, so omitting follows.
    ...(crumb.url ? { item: toAbsoluteUrl(crumb.url) } : {}),
  })),
});

export type { BreadcrumbTrailItem };
